// extracted by mini-css-extract-plugin
export var container = "dashboard-module--container--0c335";
export var dashboard = "dashboard-module--dashboard--93c9c";
export var header = "dashboard-module--header--48dbd";
export var navigation = "dashboard-module--navigation--9a1f7";
export var title = "dashboard-module--title--a8e5f";